import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WifiOff } from 'lucide-react';
import { useEffect, useState } from 'react';
/**
 * Shows a small banner when the browser goes offline. Purely additive — it
 * never blocks the UI. Field engineers rely on this to know their typed work
 * notes are saved locally (see the visit form's localStorage draft) and will
 * sync when signal returns.
 */
export function OfflineIndicator() {
    const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);
    useEffect(() => {
        const up = () => setOnline(true);
        const down = () => setOnline(false);
        window.addEventListener('online', up);
        window.addEventListener('offline', down);
        return () => {
            window.removeEventListener('online', up);
            window.removeEventListener('offline', down);
        };
    }, []);
    if (online)
        return null;
    return (_jsxs("div", { className: "flex items-center justify-center gap-2 bg-amber-500 px-3 py-1 text-center text-xs font-medium text-white", children: [_jsx(WifiOff, { size: 14 }), "You're offline \u2014 changes you type are saved on this device and will sync when you reconnect."] }));
}
